import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { ENDPOINTS } from "../config/api";
import "../styles/Instrumentacion.css";

const Instrumentacion = () => {
  const [estaciones, setEstaciones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleRowClick = (estacion) => {
    // Navega a Estaciones.js con el ID de la estación como parámetro
    navigate(`/estaciones?estacion=${estacion.nombre || estacion.estacion}`);
  };

  useEffect(() => {
    const fetchEstaciones = async () => {
      try {
        setLoading(true);
        const response = await fetch(ENDPOINTS.estaciones);
        if (!response.ok) {
          throw new Error("Error al obtener los datos de las estaciones");
        }
        const data = await response.json();
        setEstaciones(data);
      } catch (err) {
        setError(err.message);
        if (process.env.NODE_ENV === 'development') {
          console.error("Error fetching estaciones:", err);
        }
      } finally {
        setLoading(false);
      }
    };

    fetchEstaciones();
  }, []);

  const renderTablaEstaciones = () => {
    if (loading) {
      return (
        <div className="instrumentacion-loading">
          <p>Cargando datos de las estaciones...</p>
        </div>
      );
    }

    if (error) {
      return (
        <div className="instrumentacion-error">
          <p>Error: {error}</p>
        </div>
      );
    }

    if (!estaciones || estaciones.length === 0) {
      return (
        <div className="instrumentacion-no-data">
          <p>No hay datos de estaciones disponibles</p>
        </div>
      );
    }

    return (
      <div className="table-responsive">
        <table className="instrumentacion-table">
          <thead>
            <tr>
              <th>Estación</th>
              <th>Ubicación</th>
              {/* <th>Marca Digitalizador</th>
              <th>Marca Velocidad</th>
              <th>Modelo Velocidad</th>
              <th>Marca Aceleración</th>
              <th>Modelo Aceleración</th> */}
              <th>Latitud</th>
              <th>Longitud</th>
              <th>Elevación</th>
            </tr>
          </thead>
          <tbody>
            {estaciones.map((estacion, index) => (
              <tr
                key={estacion.codigo || index}
                onClick={() => handleRowClick(estacion)}
                className="instrumentacion-table-row-clickable"
                title={`Haz clic para ver la ubicación de ${estacion.nombre || estacion.estacion} en el mapa`}
              >
                  <td>
                    <p>{estacion.nombre || estacion.estacion || "N/A"}</p>
                  </td>
                <td>
                  <p>{estacion.localidad || "N/A"}</p>
                </td>
                {/* <td>
                  <p>{estacion.marcaDi || "N/A"}</p>
                </td>
                <td>
                  <p>{estacion.marcaVe || "N/A"}</p>
                </td>
                <td>
                  <p>{estacion.modeloVe || "N/A"}</p>
                </td>
                <td>
                  <p>{estacion.marcaAc || "N/A"}</p>
                </td>
                <td>
                  <p>{estacion.modeloAc || "N/A"}</p>
                </td> */}
                <td>
                  <p>{estacion.latitud || "N/A"}</p>
                </td>
                <td>
                  <p>{estacion.longuitud || "N/A"}</p>
                </td>
                <td>
                  <p>{estacion.elevacion || "N/A"}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="presentation-page pt-16">
      <header className="instrumentacion-hero-section">
        <div className="instrumentacion-hero-content">
          <div className="instrumentacion-hero-container">
            <div className="instrumentacion-hero-card">
              <div className="instrumentacion-hero-grid">
                <div className="instrumentacion-hero-left">
                  <h1 className="instrumentacion-hero-title">
                    <span className="instrumentacion-hero-title-gradient">Instrumentación</span> de las Estaciones de
                    <span className="instrumentacion-hero-title-gradient"> RESNOM</span>
                  </h1>
                </div>
                <div className="instrumentacion-hero-right">
                  <p className="instrumentacion-hero-description">
                    La Red Sísmica del Noroeste de México utiliza tecnología de vanguardia para el monitoreo continuo de
                    la actividad sísmica. Conoce los diferentes tipos de equipos y su funcionamiento.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
      <section className="instrumentacion-antecedentes-section">
        <div className="instrumentacion-antecedentes-container">
          <div className="instrumentacion-antecedentes-content">
            <div className="instrumentacion-antecedentes-text">
              <h2 className="instrumentacion-antecedentes-title">
                <span className="instrumentacion-antecedentes-title-gradient">Antecedentes</span>
              </h2>
              <p className="instrumentacion-antecedentes-description">
                Historia de la instrumentación sísmica en RESNOM
              </p>
              <p className="instrumentacion-antecedentes-text">
                La primer instrumentación de RESNOM operó de 1978 a junio 2013. Las estaciones estaban equipadas con
                convertidores analógico/digital de 12 bits, diseñados y construidos por el CICESE durante el periodo
                1978-1979. Estos sistemas estaban acoplados a tres sismómetros de período corto, Teledyne Geotech
                (S-500) o Mark L4C para registrar la señal sísmica en las direcciones Norte-Sur, Este-Oeste y Vertical.
                Las señales detectadas se digitalizaban in-situ a una razón de 40 muestras por segundo en cada
                componente y se transmitían en tiempo real, vía radios VHF y UHF, al centro de procesado en el CICESE.
              </p>
            </div>
            <div className="instrumentacion-antecedentes-image">
              <img
                src={`${process.env.PUBLIC_URL}/assets/img/casetaEst.jpg`}
                alt="Antecedentes de la Instrumentación"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="instrumentacion-evolucion-section">
        <div className="instrumentacion-evolucion-container">
          <div className="instrumentacion-evolucion-content">
            <div className="instrumentacion-evolucion-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/antenaSAT.jpg`} alt="Antena satelital de la RESNOM" />
            </div>
            <div className="instrumentacion-evolucion-text">
              <h2 className="instrumentacion-evolucion-title">
                <span className="instrumentacion-evolucion-title-gradient">Evolución</span> Tecnológica
              </h2>
              <p className="instrumentacion-evolucion-description">Desarrollo de sistemas de monitoreo avanzados</p>
              <p className="instrumentacion-evolucion-text">
                A principios del año 1993 fue incorporada al sistema RESNOM una estación de periodo largo, que se
                encontraba instalada en el sótano del edificio de Ciencias de la Tierra, y operó hasta el 2012. La
                estación consistía en tres sismómetros Teledyne Geotech (Modelos 7505 y 8700) conectados a un sistema de
                registro digital diseñado en el laboratorio de electrónica de RESNOM. El sistema digitalizaba las
                señales a razón de 1 muestra por segundo por canal, utilizando un convertidor A/D de 12 bits.
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="instrumentacion-actual-section">
        <div className="instrumentacion-actual-container">
          <div className="instrumentacion-actual-content">
            <div className="instrumentacion-actual-text">
              <h2 className="instrumentacion-actual-title">
                <span className="instrumentacion-actual-title-gradient">Instrumentación</span> Actual de la{" "}
                <span className="instrumentacion-actual-title-gradient">RESNOM</span>
              </h2>
              <p className="instrumentacion-actual-description">Tecnología de vanguardia para el monitoreo sísmico</p>
              <p className="instrumentacion-actual-text">
                Las primeras estaciones de banda ancha de la RESNOM se instalaron en 2001 y operaron hasta 2011,
                utilizando grabadoras digitales, sensores tri-axiales y GPS para control de tiempo. Tras el sismo del 4
                de abril de 2010 (M7.2), se renovó y amplió la red con apoyo de Conacyt y el Gobierno de Baja
                California, instalando 14 estaciones modernas entre 2011 y 2012.
              </p>
              <p className="instrumentacion-actual-text">
                Actualmente, RESNOM cuenta con 24 estaciones de banda ancha equipadas con sensores y digitalizadores de
                alta precisión que registran datos sísmicos a 100 muestras por segundo. Las señales se transmiten en
                tiempo real al CICESE mediante internet convencional y satelital, donde se procesan automáticamente para
                detectar eventos, calcular su localización y magnitud, y almacenar la información en una base de datos
                especializada.
              </p>
            </div>
            <div className="instrumentacion-actual-image">
              <img src={`${process.env.PUBLIC_URL}/assets/img/SensoresBA.jpg`} alt="Sensores de banda ancha" />
            </div>
          </div>
        </div>
      </section>
      <section className="instrumentacion-tabla-section">
        <div className="instrumentacion-tabla-container">
          <div className="instrumentacion-tabla-header">
            <h2 className="instrumentacion-tabla-title">Tabla de Instrumentación</h2>
            <p className="instrumentacion-tabla-description">Información de las estaciones de la red</p>
          </div>

          <div className="instrumentacion-tabla-card">{renderTablaEstaciones()}</div>
        </div>
      </section>
    </div>
  );
};

export default Instrumentacion;
